import { Injectable, inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from "@angular/router";
import { Functionality } from "../shared/constants/functionality.constants";
import { PermissionService } from "../shared/services/permission.service";

@Injectable({
  providedIn: "root",
})
export class FunctionalityGuardService {
  constructor(
    private permissionService: PermissionService,
    private router: Router
  ) {}

  /**
   * Determines whether a route requiring the given functionality can be activated.
   * @param functionality The functionality the route requires
   * @return True if the functionality is enabled, or a UrlTree redirecting to /landing otherwise
   */
  canActivate(functionality: Functionality): boolean | UrlTree {
    if (this.permissionService.isEnabled(functionality)) {
      return true;
    } else {
      return this.router.createUrlTree(["/landing"]);
    }
  }
}

/**
 * Restricts a route to users whose role enables the functionality set in the route's
 * `data.functionality`.
 */
export const FunctionalityGuard: CanActivateFn = (route: ActivatedRouteSnapshot): boolean | UrlTree => {
  return inject(FunctionalityGuardService).canActivate(route.data["functionality"] as Functionality);
};
